
class SignInController {
  /* @ngInject */
  constructor(
    $window, $state, $location, $rootScope, Auth, AUTH_EVENTS, Session, urls, $http
  ) {
    this.$window = $window;
    this.$state = $state;
    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.Auth = Auth;
    this.urls = urls;
    this.AUTH_EVENTS = AUTH_EVENTS;
    this.Session = Session;
  }

  $onInit() {
    const user = this.Session.read('userinfo');
    this.updatePageTags();
    this.setUtm();
    if (user) {
      return this.$state.go('home', this.$state.params);
    }

    this.objects = [
      { object: 'https://www.shoppre.com/img/images/International-shipping-offers.png', link: 'https://www.shoppre.com/first-time-international-shipment-offer' },
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/151ef850-762f-4615-8b37-b40e18a6f9e3.png', link: 'https://www.shoppre.com/myntra-online-shopping' },
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/277ea556-ba03-4ef1-b9ba-23890f9afc26.png', link: 'https://www.shoppre.com/amazon-great-indian-festival-sales-offers-prime-members-shopping-deals-shipping'},
      { object: 'https://mcusercontent.com/8f7212d51aa9533c4788ccf05/images/733101fd-34d1-41ca-b3df-e83cce4e5acf.png', link: 'https://www.shoppre.com/flipkart-big-billion-days-sale-offers-top-brands-stores' },
      //{ object: 'https://www.shoppre.com/img/images/MoreSavings.png', link: 'https://www.shoppreparcels.com/offers/ship-more-save-more/' },
      //{ object: 'https://www.shoppre.com/img/images/students-shipping-offer.png', link: 'https://www.shopprecouriers.com/best-international-courier-service-for-students' },
      // { object: 'assets/images/refer-earn-shoppre-shopper-shopping.png', link: 'https://ship.shoppre.com/refer-and-earn-with-us/' },
    ];

    if (this.$state.params.state) {
      const stateData = JSON.parse(atob(this.$state.params.state));
      this.$state.params.client_id = stateData.client_id;
      this.$location.search().client_id = stateData.client_id;
      this.$location.search().continue = stateData.continue;
      this.$state.params.continue = stateData.continue;
    }
    this.message = this.$state.params.message;

    if (this.$state.params.type) {
      this.$state.params.client_id = this.$state.params.client_id || this.$location.search().client_id;
    }

    if (this.$state.params.type) {
      this.$state.params.client_id = this.$state.params.client_id || this.$location.search().client_id;
    }

    this.error = null;
    this.user = {
      username: this.$state.params.username || '',
      password: this.$state.params.password || '',
    };

    if (this.$state.params.code
    || (this.$state.params.username && this.$state.params.password)) {
      return this.signin(this.$state.params.code, this.$state.params.type, this.$state.params.client_id);
    }

    this.show = true;
    return null;
  }

  updatePageTags() {
    var link = document.createElement('meta');
    link.setAttribute('name', 'description');
    link.content = 'Hey welcome back! Log in to your ShoppRe account to access your package details, status, wallet balance, and secure online payment and shipping services';
    this.$window.document.getElementsByTagName('head')[0].appendChild(link);

    var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    this.$window.document.head.appendChild(link);

    var link = document.createElement('meta');
    link.setAttribute('name', 'robot');
    link.content = 'noindex';
    this.$window.document.getElementsByTagName('head')[0].appendChild(link);
  }

  getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  setUtm() {
    if (this.$state.params.utm_source && this.$state.params.utm_source != 'undefined') {
      document.cookie = `utm_source=${this.$state.params.utm_source};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_campaign && this.$state.params.utm_campaign != 'undefined') {
      document.cookie = `utm_campaign=${this.$state.params.utm_campaign};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.utm_medium && this.$state.params.utm_medium != 'undefined') {
      document.cookie = `utm_medium=${this.$state.params.utm_medium};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.original_source && this.$state.params.original_source != 'undefined') {
      document.cookie = `original_source=${this.$state.params.original_source};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.parameter_url && this.$state.params.parameter_url != 'undefined') {
      document.cookie = `parameter_url=${this.$state.params.parameter_url};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.gcl_id && this.$state.params.gcl_id != 'undefined') {
      document.cookie = `gcl_id=${this.$state.params.gcl_id};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.referrer && this.$state.params.referrer != 'undefined') {
      document.cookie = `referrer=${this.$state.params.referrer};domain=${this.urls.DOMAIN};`;
    }
    if (this.$state.params.first_visit && this.$state.params.first_visit != 'undefined') {
      document.cookie = `first_visit=${this.$state.params.first_visit};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.post_login_page && this.$state.params.post_login_page != 'undefined') {
      document.cookie = `post_login_page=${this.$state.params.post_login_page};domain=${this.urls.DOMAIN};`;
    }

    if (this.$state.params.collect_coupon && this.$state.params.collect_coupon != 'undefined') {
      document.cookie = `collect_coupon=${this.$state.params.collect_coupon};domain=${this.urls.DOMAIN};`;
    }
    const fromDomain = this.getCookie('from_domain');

    if (this.$state.params.from_domain && this.$state.params.from_domain != 'undefined' && fromDomain != '') {
      document.cookie = `from_domain=${this.$state.params.from_domain};domain=${this.urls.DOMAIN};`;
    } else {
      document.cookie = `from_domain=${this.urls.DOMAIN};domain=${this.urls.DOMAIN};`;
    }
  }


  signin(code, type, clientId) {
    this.error = null;
    this.show = false;

    const { username, password } = this.user;

    const utmSource = this.getCookie('utm_source');
    const utmMedium = this.getCookie('utm_medium');
    const utmCampaign = this.getCookie('utm_campaign');
    const originalSource = this.getCookie('original_source');
    const parameterUrl = this.getCookie('parameter_url');
    const gclId = this.getCookie('gcl_id');
    const fromDomain = this.getCookie('from_domain');
    const referrer = this.getCookie('referrer');
    const firstVisit = this.getCookie('first_visit');
    const collectCoupon = this.getCookie('collect_coupon');

    let options = {};
    if (utmSource) {
      options = {
        username,
        password,
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        original_source: originalSource,
        parameter_url: parameterUrl,
        gcl_id: gclId,
        from_domain: fromDomain,
        referrer: referrer,
        first_visit: firstVisit,
        collect_coupon: collectCoupon,
      };
    } else {
      options = {
        username,
        password,
        collect_coupon: collectCoupon,
      };
    }

    // Try to login
    this.Auth
      .login(code ? { grant_type: type, code, client_id: clientId,
        utm_medium: utmMedium, utm_source: utmSource, utm_campaign: utmCampaign,
        original_source: originalSource, parameter_url: parameterUrl, gcl_id: gclId,
        from_domain: fromDomain, first_visit: firstVisit, referrer, collect_coupon: collectCoupon
      } : options)
      .then(() => {
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginSuccess);
        this.Auth
          .setSessionData()
          .then(() => {
            const { $location, $state } = this;
            const { whatBlocked = [] } = this.Session.read('userinfo') || {};
            const [state] = whatBlocked.map((x) => x.state);
            if (state === 'password-change') return $state.go(state);

            const stateOptions = {};
            if (![undefined, 'undefined', null].includes(this.$location.search().client_id)) {
              stateOptions.client_id = this.$location.search().client_id;
            }
            let continueUrl = this.getCookie('post_login_page');
            if (continueUrl) {
              this.$location.search().continue = continueUrl;
              stateOptions.continue =continueUrl;
            } else if ($location.search().continue) {
                stateOptions.continue = this.$location.search().continue;
            }
            if (!stateOptions.client_id && $location.search().client_id) {
              stateOptions.client_id = this.$location.search().client_id;
            }

            const user = this.Session.read('userinfo');
            const that = this;
            if (user) {
              const { LOGIN_APP } = this.urls;
              const url = `${LOGIN_APP}/api/users/${user.id}`;

              this.$http.get(url)
                .then(({ data }) => {
                  const userCreated = new Date(data.created_at).toISOString().slice(0, 10);
                  const checkDate = new Date(data.emailVerificationStartDate).toISOString().slice(0, 10);

                  if (!data.is_email_verified && userCreated >= checkDate) {
                    that.show = true;
                    this.Session.remove('userinfo');
                    return this.message = 'Please verify your Email id';
                  } else {
                    return $state.go('home', stateOptions);
                  }
                });
            }
            else {
              return $state.go('home', stateOptions);
            }
          });
      }, ({ data }) => {
        this.show = true;
        this.$rootScope.$broadcast(this.AUTH_EVENTS.loginFailed);
        this.error = data.error_description;
      });
  }

  socialRedirect(type) {
    const { LOGIN_APP } = this.urls;
    const query = this.$location.search();
    let url = `${LOGIN_APP}/api/oauth`;

    if (type === 'google') {
      url += `/google?continue=${query.continue}&client_id=${query.client_id}`;
    } else {
      url += `/facebook?continue=${query.continue}&client_id=${query.client_id}`;
    }
    // this.$window.location.href = url;
    this.$http.get(url).then(({ data }) => {
      this.$window.location.href = data.redirectUrl;
    });
  }
}

export default SignInController;



// WEBPACK FOOTER //
// ./client/app/oauth/sign-in/sign-in.controller.js